import { render, staticRenderFns } from "./welfareRewards.vue?vue&type=template&id=0309b79e"
import script from "./welfareRewards.vue?vue&type=script&lang=js"
export * from "./welfareRewards.vue?vue&type=script&lang=js"
import style0 from "./welfareRewards.vue?vue&type=style&index=0&id=0309b79e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports